import { createSSRApp } from 'vue'
import App from './App.vue'
import uviewPlus, { setConfig } from 'uview-plus'
import 'uno.css'
import { pinia, setupStore } from './stores'
import { http } from './utils/http/index'
// import UVIEW_CUSTOM_CONFIG from './styles/uview-override'
import zPagingConfig from './utils/z-paging'

export function createApp() {
  const app = createSSRApp(App)

  setConfig({
    props: {
      input: {
        cursor: 0,
        cursorColor: '#07C160'
      }
    }
  })

  app.use(uviewPlus)

  // 注册 pinia
  app.use(pinia)

  // 初始化 store
  setupStore()

  // 添加全局属性
  app.config.globalProperties.$http = http

  // 全局配置 z-paging
  // 使用 uni.$zp.config 设置 z-paging 全局配置
  ;(uni as any).$zp = (uni as any).$zp || {}
  ;(uni as any).$zp.config = {
    ...(uni as any).$zp.config,
    ...zPagingConfig
  }

  return {
    app
  }
}
